import React from "react";
import logo from "../../assets/images/arcese_logo_text_red.svg";
import DotFlashing from "../ui/loaders/dotFlashing/DotFlashing";

const ApplicationFallback: React.FC = () => {
    return (
        <div className="h-[100dvh] w-screen flex justify-center items-center">
            <div className="ml-10 mb-16 flex flex-col items-center">
                <img src={logo} className="block h-[45px] w-auto" alt="Logo Arcese" />
                <DotFlashing />
            </div>
        </div>
    )
}

export default ApplicationFallback;